type ChatwootWindow = Window & {
  chatwootSettings?: {
    position: string;
    type: string;
    launcherTitle: string;
  };
  chatwootSDK?: {
    run(options: { websiteToken: string; baseUrl: string }): void;
  };
};

function applyChatwootPurpleStyle(): void {
  const chatBtn = document.querySelector<HTMLElement>(".woot-widget-bubble");
  if (!chatBtn) return;

  chatBtn.style.removeProperty("background");
  chatBtn.style.removeProperty("background-color");

  if (!window.matchMedia("(max-width: 989px)").matches) return;

  chatBtn.style.setProperty("width", "64px", "important");
  chatBtn.style.setProperty("min-width", "64px", "important");
  chatBtn.style.setProperty("height", "64px", "important");
  chatBtn.style.setProperty("min-height", "64px", "important");
  chatBtn.style.setProperty("padding", "0", "important");
  chatBtn.style.setProperty("border-radius", "50%", "important");
  chatBtn.style.setProperty("overflow", "hidden", "important");
  chatBtn.style.setProperty("display", "flex", "important");
  chatBtn.style.setProperty("align-items", "center", "important");
  chatBtn.style.setProperty("justify-content", "center", "important");

  const bubbleText = chatBtn.querySelector<HTMLElement>(
    "#woot-widget--expanded__text, .woot-widget-bubble-text"
  );
  bubbleText?.style.setProperty("display", "none", "important");
}

export function initChatwootWidget(): void {
  const placeholder = document.getElementById("chatwoot-placeholder");
  if (!placeholder) return;

  const launcher = placeholder;
  const baseUrl = placeholder.dataset.chatwootBaseUrl || "https://support.remerlinds.com";
  const websiteTokenValue = placeholder.dataset.chatwootToken;
  if (!websiteTokenValue) return;
  const websiteToken = websiteTokenValue;

  let loaded = false;

  function loadChatwoot(openAfter: boolean): void {
    if (loaded) return;
    loaded = true;
    launcher.classList.add("loading");

    const cw = window as ChatwootWindow;
    cw.chatwootSettings = {
      position: "right",
      type: "expanded_bubble",
      launcherTitle: "Ask Nyx"
    };

    const script = document.createElement("script");
    script.src = `${baseUrl}/packs/js/sdk.js`;
    script.async = true;
    document.body.appendChild(script);

    script.onerror = () => {
      loaded = false;
      launcher.classList.remove("loading");
    };

    script.onload = () => {
      cw.chatwootSDK?.run({ websiteToken, baseUrl });

      const observer = new MutationObserver(() => {
        const realBtn = document.querySelector<HTMLElement>(".woot-widget-bubble");
        if (!realBtn) return;

        observer.disconnect();
        applyChatwootPurpleStyle();
        launcher.style.display = "none";

        if (openAfter) {
          setTimeout(() => realBtn.click(), 300);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        applyChatwootPurpleStyle();
        launcher.style.display = "none";
      }, 5000);
    };
  }

  launcher.addEventListener("click", () => loadChatwoot(true));
}
